import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  AfterViewInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  HostBinding
} from '@angular/core';

import { Router,ActivatedRoute } from '@angular/router';

declare var $: any;

import {SectionI} from '../types';

import { ToastrService } from 'ngx-toastr';

import {AppSettings} from '../settings';

import {CommonService} from '../services/common.service';
//import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'boxes',
  templateUrl: './boxes.component.html',
  styleUrls: ['./boxes.component.css'],

  encapsulation: ViewEncapsulation.None,
})
export class BoxComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {


  @ViewChild('topElement', {static: false}) telef !: ElementRef;
  @ViewChild('parElement', {static: false}) pelef !: ElementRef;
  @ViewChild('bElement', {static: false}) belef!: ElementRef;
  @ViewChild('cardElement', {static: false}) celef!: ElementRef;

  @HostBinding('style.width') public width: string = '100%'; 

  
  @Input() pos: number;

  @Input() element_pos: number;

  @Input() element: any;

  @Output() deleteBox = new EventEmitter();

  newsletterid:any;
 
  url:any=AppSettings.API_ENDPOINT

  


  @Output() custom_box_event = new EventEmitter();

  commonService:any;

  constructor(private cmmonService:CommonService,private route: ActivatedRoute,private toastr: ToastrService) {
    
    this.newsletterid = +this.route.snapshot.paramMap.get('id');
    
    this.commonService = cmmonService;
  }

  dragInner() {


  }

  ngOnChanges(ch: SimpleChanges) {


  }

  ngOnInit() {

    //use for gtm

    if(AppSettings.GTM_ID){
      //this.gtmService.addGtmToDom();
    }
    

  }

  ngOnDestroy() {


  }

  ngAfterViewInit() {



  }



  allowDrop(ev) {

      ev.preventDefault();

  }


  IsJsonString(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
  }

  drop(ev: any) {


    try{


 


     // var data1 = (ev.dataTransfer.getData("innerDrag")!=undefined)?ev.dataTransfer.getData("innerDrag"):[];

     
      var data2 = (ev.dataTransfer.getData("text")!=undefined)? ev.dataTransfer.getData("text"):[];
 
 
      
 
      // if (data1.length == 0 && data2.length == 0) {
      //    ev.stopPropagation();
      //     return;
 
      // }
 
 
       if (data2.length != 0 && this.IsJsonString(data2)) {
 
           var data = JSON.parse(data2);
 
           let text= this.element.type.split('_').join(" ") +" only drag here"
 
           if(this.element.type == data.type && data.action=='insert'){
 
 
                     this.custom_box_event.emit({
                         'data': data,
                         'pos': this.pos,
                         'epos': this.element_pos,
                         'type': 'insert'
                     })
 
           }
           
          else if(this.element.type == data.type && data.action=='swap'){
 
 
            this.custom_box_event.emit({
              'data': data,
              'element': this.element,
              'pos': this.pos,
              'epos': this.element_pos,
              'type': 'swap'
             });


          }
           
           else{
 
            
     
             this.toastr.error(text, '', {
               timeOut: 3000
             });
         }
 
   
 
       }
 
   /*   if (data1.length != 0 && this.IsJsonString(data1)) {
 
           var data = JSON.parse(data1);
 
           let text= this.element.type.split('_').join(" ") +" only drag here"          
      
 
           if(this.element.type == data.type){
 
               this.custom_box_event.emit({
               'data': data,
               'element': this.element,
               'pos': this.pos,
               'epos': this.element_pos,
               'type': 'swap'
              });
 
           }else{
 
             console.log(text);
     
             this.toastr.error(text, '', {
               timeOut: 3000
             });
         }
 
 
   
 
       }
 */
     
 
 
       ev.stopPropagation();
       return false;




    }catch(ex){

      ev.stopPropagation();
      return ;
    }

    
  }


  delBox(indx){

    this.deleteBox.emit(indx)

  }




}
